export const BadRequestConstants = {
  somethingWentWrong: 'Something went wrong:',
  invalidClientID: 'Invalid or missing client_id',
  invalidRedirectURI: 'Invalid or missing redirect_uri',
  invalidResponseType: 'Invalid or missing response_type',
  invalidPKCE: 'Invalid or missing PKCE',
};
